import { render, staticRenderFns } from "./TemplateRelatorio.vue?vue&type=template&id=3cf3905b&"
import script from "./TemplateRelatorio.vue?vue&type=script&lang=js&"
export * from "./TemplateRelatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports